import React, { useState, useEffect } from "react"
import Block from "@bappweb/block"
import "../assetsv2/style.scss"
import "../../../../../assets/styles/style.scss"
import "../../assets/style.scss"
import Carousel from "@bappweb/carousel"
import { useDeviceSize, Sizes } from "@bappweb/provider"
import { useAppSelector } from "../../../config/hook"
import { getConfigValue, isNullOrEmpty } from "@smpu-web/utils/utils"

const CampaignCarousel = () => {
    let size = useDeviceSize()

    const [campaignsCarousels, setCampaignsCarousels] = useState<any[]>([]);
    const sessionData = useAppSelector((state) => state.sessionData.response)

    useEffect(() => {
        if (sessionData?.configList && !isNullOrEmpty(getConfigValue(sessionData?.configList, "PosBasvuru.Landing.CampaignText.Carousel.Bottom"))) {
            setCampaignsCarousels(JSON.parse(getConfigValue(sessionData?.configList, "PosBasvuru.Landing.CampaignText.Carousel.Bottom")))
        }
    }, [sessionData])

    return (
        <Block className="container carousel-container">
            <Block className="carousel-box">
                <Carousel
                    afterChange={function noRefCheck() { }}
                    arrows
                    beforeChange={function noRefCheck() { }}
                    id="unique_id"
                    infinite={false}
                    initialSlide={0}
                    responsive={[
                        {
                            breakpoint: 4,
                            settings: {
                                slidesToScroll: 1,
                                slidesToShow: 3
                            }
                        }
                    ]}
                    slidesToScroll={size}
                    slidesToShow={size}
                    autoplay={false}
                    focusOnSelect={false}
                    variableWidth={false}
                    dots={true}
                    adaptiveHeight={false}
                    vertical={false}
                    centerMode={false}
                >
                    {campaignsCarousels && campaignsCarousels.map((item: any, index) => {
                        return (
                            <Block key={index} dangerouslySetInnerHTML={{ __html: item?.data }} />
                        )
                    })}
                </Carousel>
            </Block>
        </Block>
    )
}

export default CampaignCarousel
